import { Loader, Message, toaster } from "rsuite";
import { ApiResponseContainer } from "../models/api";

export const showErrorToast = (error: ApiResponseContainer<any>) => {
  toaster.push(
    <Message showIcon type="error" duration={5000}>
      {error.message || error.title || "Something went wrong"}
    </Message>,
    { placement: "bottomEnd" }
  );
  return error;
};

export const showSuccessToast = (message: string) => {
  return toaster.push(
    <Message showIcon type="success" duration={5000}>
      {message}
    </Message>,
    { placement: "bottomEnd" }
  );
};

export const showToast = (
  message: string,
  type: "success" | "error" | "info" = "success",
  placement:
    | "topCenter"
    | "bottomCenter"
    | "topStart"
    | "topEnd"
    | "bottomStart"
    | "bottomEnd" = "bottomEnd",
  duration: number = 5000,
  closable = false
) => {
  return toaster.push(
    <Message showIcon type={type} duration={duration} closable={closable}>
      {message}
    </Message>,
    {
      placement: placement,
    }
  );
};

export const showLoadingToast = (message: string, duration?: number) => {
  return toaster.push(
    <Message showIcon type="info" duration={duration ?? 5000}>
      <Loader /> {message}
    </Message>,
    { placement: "bottomEnd" }
  );
};

export const showPaginatedTableToast = (
  errorType: "error" | "info" | "success",
  message?: string
) => {
  return toaster.push(
    <Message showIcon type={errorType}>
      {message || "A problem faced while getting data"}
    </Message>,
    { placement: "bottomEnd" }
  );
};
